import $http from "../axios";

const state = {
  merchants: [],
  storeBeingManaged: {}
};

const getters = {
  merchants: state => state.merchants,
  stores: state => state.merchants.flatMap(m => m.stores || []),
  storeBeingManaged: state => state.storeBeingManaged
};

const actions = {
  getStores({ commit }, date) {
    return new Promise((resolve, reject) => {
      $http
        .get(`stores?date=${date}`)
        .then(res => {
          if (res.data.result === "ok") {
            commit("SET_MERCHANTS", res.data.payload.merchants);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  findUser(_, email) {
    return new Promise((resolve, reject) => {
      $http
        .get(`find-user?email=${email}`)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  addUserToBuyNowPayLaterList({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`add-user-buy-now-pay-later`, {
          storeId: data.storeId,
          userId: data.user._id
        })
        .then(res => {
          if (res.data.result === "ok") {
            commit("ADD_USER_BUY_NOW_PAY_LATER", res.data.payload.user);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  removeBuyNowPayLaterUser({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`remove-user-buy-now-pay-later`, data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("REMOVE_USER_BUY_NOW_PAY_LATER", data);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  setStoreBeingManaged({ commit }, store) {
    commit("SET_STORE_BEING_MANAGED", store);
  },

  clearStores({ commit }) {
    commit("CLEAR_STORES");
  }
};

const mutations = {
  SET_MERCHANTS(state, merchants) {
    state.merchants = merchants;
  },

  SET_STORE_BEING_MANAGED(state, store) {
    state.storeBeingManaged = store;
  },

  ADD_USER_BUY_NOW_PAY_LATER(state, user) {
    state.storeBeingManaged.payments.buyNowPayLater.users.push(user);
  },

  REMOVE_USER_BUY_NOW_PAY_LATER(state, data) {
    const userIndex =
      state.storeBeingManaged.payments.buyNowPayLater.users.findIndex(u => {
        return u._id === data.userId;
      });
    if (userIndex > -1) {
      state.storeBeingManaged.payments.buyNowPayLater.users.splice(
        userIndex,
        1
      );
    }
  },

  CLEAR_STORES(state) {
    state.merchants = [];
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
